/**
 * ⚠️ Load options every glTF ScenegraphLayer on this map MUST carry — the R160's six
 * subway GLBs and the Xcelsior's three bus GLBs alike. Not tuning: without them the
 * meshes never decode in a hosted build.
 *
 * All of them are `KHR_draco_mesh_compression`, and loaders.gl resolves the Draco decoder
 * from `https://unpkg.com/@loaders.gl` by DEFAULT. The site's CSP allows connect-src to
 * self + the API + the tile host only (`scripts/gen-headers.mjs`), so that request is
 * refused, the decoder never arrives, and the layer draws nothing.
 *
 * The failure is silent AND distance-dependent, which is what makes it so easy to misread
 * as a data outage: far away a train is an IconLayer bullet and looks perfect, but once the
 * bullet layer (`train-marker`, data `markerFront`) hands off to the mesh, zooming IN makes
 * every vehicle vanish while the feed, the socket and the route lines all stay healthy.
 *
 * `modules` is consulted before the CDN branch in loaders.gl's resolver, so it wins
 * outright; `CDN: null` removes the fallback as well. `worker: false` is not optional —
 * the Draco *worker* script is fetched from unpkg too, and public/modules vendors the
 * decoder but not the worker, so decoding runs on the main thread. That costs nothing at
 * this scale: nine small meshes, decoded once each per session.
 *
 * ⚠️ `worker: false` also decides HOW the wrapper runs: on the main thread loaders.gl
 * fetches it as text and injects it as an INLINE `<script>` (worker-utils
 * `loadLibraryFromFile`), so the hosted CSP must carry that file's sha256 —
 * `scripts/gen-headers.mjs` computes it from dist/. Re-vendoring the decoder without
 * rebuilding the headers blocks the wrapper and the meshes stop decoding, with only the
 * decal IconLayers left drawing.
 *
 * One frozen module-level object on purpose: `buildVehicleLayers` runs every frame and deck
 * diffs props by identity, so a fresh literal per frame would rebuild the layers forever.
 */
export const VENDORED_GLB_LOAD_OPTIONS = Object.freeze({
  modules: {
    'draco_decoder.wasm': '/modules/draco/src/libs/draco_decoder.wasm',
    'draco_wasm_wrapper.js': '/modules/draco/src/libs/draco_wasm_wrapper.js',
  },
  core: { CDN: null, useLocalLibraries: true, worker: false },
})
